export const getLanguage = state => state.language.currentLanguage;

export const getLanguagePublic = state => state.language.currentLanguagePublic;
